module.exports = __webpack_public_path__ + "static/media/materials-icon.2d6cc928.svg";